import React from "react";
import { IProductTilesProps } from "../../../types/suggestion-items";
import ProductTile from "./product-tile";
import ResultButton from "./result-button";
import FlexibleSetTile from "./flexible-set-tile";

const ProductTiles = (props: IProductTilesProps) => {
    const shouldCustomerSeePrices =
        props.customerType === "Company" || props.customerType === "Surgery";
    const hideProductInfo = shouldCustomerSeePrices && props.isMobileShop;
    const productViewMode = hideProductInfo ? "compact" : "expanded";

    return (
        <div className={"article-column-container " + (props.hasLeftListItems ? "padded" : "")}>
            {props.products.headline && (
                <span
                    className={`suggestions-text ${props.products.headline.type.toLowerCase()} not-selectable`}
                    key={props.products.headline?.navIndex}
                    ref={(el) => props.setRef(props.products.headline?.navIndex ?? 0, el)}
                >
                    {props.products.headline.title}
                </span>
            )}
            <div className={`article-container ${productViewMode}`}>
                {props.products.articles.map((article, index) => (
                    <ProductTile
                        article={article}
                        key={article.navIndex}
                        setRef={props.setRef}
                        index={index}
                        showPrices={shouldCustomerSeePrices}
                        hideProductInfo={hideProductInfo}
                        priceMandantSettings={props.priceMandantSettings}
                        searchInfo={props.searchInfo}
                    />
                ))}
                {props.products.flexibleSets.map((set, index) => (
                    <FlexibleSetTile
                        product={set}
                        key={set.navIndex}
                        setRef={props.setRef}
                        index={index}
                        showPrices={shouldCustomerSeePrices}
                        hideProductInfo={hideProductInfo}
                        priceMandantSettingsV2={props.priceMandantSettingsV2}
                        searchInfo={props.searchInfo}
                    />
                ))}
                {props.products.showMoreButton && (
                    <ResultButton
                        key={props.products.showMoreButton.navIndex}
                        setRef={props.setRef}
                        navIndex={props.products.showMoreButton.navIndex}
                        target={props.products.showMoreButton.target}
                        title={props.products.showMoreButton.title}
                        searchInfo={props.searchInfo}
                    />
                )}
            </div>
        </div>
    );
};

export default ProductTiles;
